'use client';

import React from 'react';
import Header from '../global/partials/Header';
import Footer from '../global/partials/Footer';
import { PagePayoutSchema } from '@/sanity/pages/PagePayoutTemplate';
import HeroSection from '../pageComponents/payout/HeroSection';
import IntroSection from '../pageComponents/payout/IntroSection';
import TestimonialsSection from '../pageComponents/global/sections/TestimonialsSection';
import ReviewSection from '../pageComponents/payout/ReviewSection';
import ScrollingBanner from '../pageComponents/global/ScrollingBanner';
import HeaderV2 from '../global/partials/HeaderV2';
import TestimonialsSectionV2 from '../pageComponents/global/sections/TestimonialsSectionV2';
import WhatSetsApartSection from '../pageComponents/global/sections/WhatSetsApartSection';
import TradersStoriesSection from '../pageComponents/global/sections/TradersStoriesSection';
import FeaturedQuoteSection from '../pageComponents/global/sections/FeaturedQuoteSection';
import LivePayoutsSection from '../pageComponents/global/sections/LivePayoutsSection';

export default function PagePayoutJSX({ data }: { data: PagePayoutSchema }) {
  return (
    <main className="flex flex-col items-center">
      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType={'main'} // showBorder
          language={data.settings?.language}
        />
      )}
      <HeroSection data={data} />
      <ScrollingBanner
        className="bg-white border-y-0"
        words={data.scrollingWords?.words}
        wordsI18n={data.scrollingWords?.wordsI18n}
      />
      <IntroSection data={data} />
      <TestimonialsSectionV2
        language={data.settings?.language}
        data={{ ...data, testimonialsCards: data.testimonialsCardsRef }}
      />

      <WhatSetsApartSection data={data} />
      <TradersStoriesSection
        language={data.settings?.language}
        data={{
          chip: data.tradersStoriesChip,
          title: data.tradersStoriesTitle,
          items: data.tradersStoriesItemsRefs ?? data.tradersStoriesItems,
          button: data.tradersStoriesButton,
          partnerText: data.tradersStoriesPartnerText,
        }}
      />
      <LivePayoutsSection data={data} />
      <FeaturedQuoteSection data={data} />
      {/*
      <ReviewSection data={data} />
      <ScrollingBanner
        className="bg-[#f4f5f5] border-y-0"
        words={[
          'Krypto',
          'Investments',
          'Strategien',
          'Risikomanagement',
          'Rendite',
        ]}
      /> */}

      {data?.settings?.footer && <Footer data={data.settings?.footer} finalCta={data} language={data?.settings?.language} />}
    </main>
  );
}
